import { useEffect, useRef } from 'react';
import { TreeViewItem } from "@volvo/vcdk-react";

interface Props extends React.ComponentProps<typeof TreeViewItem> {
	onToggle?: (open: boolean, element: HTMLElement) => void;
}

export const CustomTreeViewItem: React.FC<Props> = ({ onToggle, children, ...rest }) => {
	const ref = useRef<any>(null);

	useEffect(() => {
		if (ref.current) {
			const element = ref.current;
			const originalToggle = element.toggle;
			element.toggle = function () {
				originalToggle.call(this);
				if (onToggle) {
					onToggle(this.open, element);
				}
			};
		}
	}, []);

	return <TreeViewItem ref={ref} {...rest}>{children}</TreeViewItem>;
};